import React, { useState, useRef } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import Search from './components/Search';
import CourseDetail from './components/CourseDetail';

const App = props => {
  const [courses, setCourses] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const tableInstanceRef = useRef()

  return (
    <Router>
      <div>
        <Route exact path="/" component={() =>
          <Search companyIds={props.companyIds} displayMode={props.displayMode}
            categoryIds={props.categoryIds} courseIds={props.courseIds}
            courses={courses} setCourses={setCourses}
            columnsToDisplay={props.columnsToDisplay}
            categories={categories} setCategories={setCategories}
            isFetching={isFetching} setIsFetching={setIsFetching}
            tableInstanceRef={tableInstanceRef}/>} />
        <Route exact path="/course/:companyId/:courseId" component={(routeProps, a, b) => 
          <CourseDetail companyId={routeProps.match.params.companyId} courseId={routeProps.match.params.courseId} />}/>
      </div>
    </Router>
  )
}

export default App;
